import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials=true so the browser sends the httpOnly `sf_auth` cookie
// on every request. We no longer attach an Authorization header; the JWT
// lives only in the cookie (XSS-safe — JS can't read it).
export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// One-time cleanup of the legacy localStorage token from earlier builds so
// nothing lingers in DevTools/Application storage.
try {
    if (typeof localStorage !== "undefined" && localStorage.getItem("sf_token")) {
        localStorage.removeItem("sf_token");
    }
} catch { /* ignore private-mode failures */ }

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            // Session expired or invalidated — drop cached profile so the UI
            // renders the logged-out state on the next render.
            try { localStorage.removeItem("sf_user"); } catch { /* noop */ }
        }
        return Promise.reject(err);
    }
);

// Persist ONLY the non-sensitive user profile (id/email/name) so the Navbar can
// render synchronously without waiting for /auth/me. The token itself lives in
// the httpOnly cookie set by the backend.
export function setAuth(user) {
    try { localStorage.setItem("sf_user", JSON.stringify(user)); } catch { /* noop */ }
}

export function getUser() {
    try {
        return JSON.parse(localStorage.getItem("sf_user") || "null");
    } catch {
        return null;
    }
}

export async function logout() {
    try { await api.post("/auth/logout"); } catch { /* fire-and-forget */ }
    try { localStorage.removeItem("sf_user"); } catch { /* noop */ }
}

export function imageUrl(path) {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    return `${BACKEND_URL}${path}`;
}
